import { Link, useNavigate } from "react-router-dom";
import IconButtonHT from "../../components/IconButtonHT";
import Search from "../../components/Search";


export default function BreadCrumbs({ params, syllabus, search, setSearch }) {

    const syl = syllabus.findById(params.syllabus);

  
return (
    <div style={{display:"flex", justifyContent: "space-between"}}>
        <Crumbs params={params} syl={syl} />
        {!params.syllabus && <Search size="small" search={search} setSearch={setSearch} />}
        <LessonChoice params={params} syllabus={syl} />
 </div>
);
}

function LessonChoice({ params, syllabus }) { 
    
    let navigate = useNavigate()

    if (!params.lessonId) return <div></div>

    const lesson = syllabus.lessons.find(l => l._id === params.lessonId)
    
    let last = undefined
    let next = undefined

    for (const l of syllabus.lessons) {
        if(l.courseLessonNumber < lesson.courseLessonNumber) last = l
        if(l.courseLessonNumber > lesson.courseLessonNumber) {
            next = l
            break
        }
    }

    return (
      <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
        <IconButtonHT
          icon="leftChevron"
          action={() =>
            navigate(
              `/teaching/syllabus/${params.syllabus}/unit/${last.unit}/lesson/${last._id}`
            )
          }
          disabled={!last}
        />
        <div>Lesson {lesson.courseLessonNumber} of 71</div>
        <IconButtonHT
          icon="rightChevron"
          action={() =>
            navigate(
              `/teaching/syllabus/${params.syllabus}/unit/${next.unit}/lesson/${next._id}`
            )
          }
            disabled={!next}
        />
      </div>
    );

}


function Crumbs({ params, syl }) {
    return (
      <div style={{ display: "flex", gap: 5, alignItems: "center" }}>
        <Link
          to={`/teaching/syllabus/`}
          className="neat"
         
        >
          Syllabus
        </Link>
        {params.syllabus && (
          <Crumb
            link={`/teaching/syllabus/${params.syllabus}`}
            name={syl.name}
          />
        )}
        {params.syllabus && params.unit && (
          <Crumb
            link={`/teaching/syllabus/${params.syllabus}/unit/${params.unit}`}
            name={`Unit ${
              syl.units.find((u) => u._id === params.unit).unitNumber
            }:  ${syl.units.find((u) => u._id === params.unit).name}`}
          />
        )}
        {params.syllabus && params.unit && params.lessonId && (
          <Crumb
            link={`/teaching/syllabus/${params.syllabus}/unit/${params.unit}/lesson/${params.lessonId}`}
            name={`Lesson ${
              syl.lessons.find((l) => l._id === params.lessonId).lessonNumber
            }: ${syl.lessons.find((l) => l._id === params.lessonId).name}`}
          />
        )}
      </div>
    );
      }


function Crumb({ name, link }) {
    return (
        <div style={{ display: "flex", gap: 5, alignItems: "center" }}>
        <IconButtonHT icon="rightChevron" />
        <Link to={link} className="neat">{name}</Link>
        </div>
    );
}